<template>
  <div class="clients">
    <HeroBanner :title="'Clients'"/>
    <div class="clients__list col1">
      <div class="clients__list__search">
        <input type="text" v-model="filterTerm" placeholder="Filter..."/>
      </div>
      <p v-if="pending && !clients.length" class="pending" v-html="'Loading...'" />
      <template v-else>
        <div class="clients__list__table">
          <table>
            <thead>
              <tr>
                <th><input type="checkbox" @click="checkAll"/></th>
                <th>Name</th>
                <th>Email</th>
                <th>Created</th>
                <th>Package</th>
                <th>Address</th>
                <th>Business Name</th>
                <th>Certification 1</th>
                <th>Certification 2</th>
                <th>Client Number</th>
                <th>Coinventors</th>
                <th>Competitors</th>
                <th>Phone</th>
                <th>Next Step</th>
              </tr>
            </thead>
            <tbody>
              <tr class="client-row" v-for="(client, i) in clients" :key="client.uid" v-show="shouldShowClient(client)">
                <td><input type="checkbox" :id="`client${i}`" :value="client.uid"/></td>
                <td :class="{ 'action-required': getStepOwner(client.timelineStep) === 'admin' && client.timelineStep < totalSteps}">
                  {{ client.firstName }} {{ client.lastName }}
                  <br/>
                  <template v-if="isAdmin">
                    <a class="view-timeline-link" @click="viewTimeline(client.uid)">Timeline</a>
                    <a class="view-docs-link" @click="viewDocs(client.uid)">Docs</a>
                    <router-link :to="`/update-profile?uid=${client.uid}`" v-html="'Profile'"/>
                  </template>
                </td>
                <td>
                  <a :href="`mailto:${ client.email }`" v-html="client.email" />
                </td>
                <td>{{ formatDate(client.dateCreated) }}</td>
                <td>{{ client.package }}</td>
                <td>{{ client.address1 }} {{ client.address2 }}<br>{{ client.city }}, {{ client.state }} {{ client.zip }}<br></td>
                <td>{{ client.businessName }}</td>
                <td>{{ client.certification1 }}</td>
                <td>{{ client.certification2 }}</td>
                <td>{{ client.clientNumber }}</td>
                <td>{{ client.coinventors }}</td>
                <td>{{ client.competitors }}</td>
                <td>{{ client.phone }}</td>
                <td>{{ client.timelineStep + 1 }}. "{{ getStepText(client.timelineStep) }}"</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="actions">
          With selected: <button class="actions__delete" @click="deleteUsers" :disabled="deleting" v-html="deleting ? 'Deleting...' : 'Delete'"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { deleteUser } from '@/library/userFunctions'
import { mapActions, mapGetters, mapState } from 'vuex'
import HeroBanner from '@/components/HeroBanner'
export default {
  name: 'Clients',
  components: {
    HeroBanner
  },
  data() {
    return {
      adminEmail: null,
      clients: [],
      deleting: false,
      filterTerm: '',
      pending: true
    }
  },
  computed: {
    ...mapGetters([
      'currentUserProfile',
      'getStepOwner',
      'getStepText',
      'totalSteps'
    ]),
    ...mapState([
      'isAdmin',
      'userProfile'
    ])
  },
  async mounted(){
    this.clients = await this.getClients()
    this.pending = false
  },
  methods: {
    ...mapActions(['getClients']),
    shouldShowClient(client) {
      if (!this.filterTerm) {
        return true
      }
      const fullName = `${client.firstName} ${client.lastName}`.toLowerCase()
      return fullName.includes(this.filterTerm.toLowerCase()) || client.email.includes(this.filterTerm)
    },
    formatDate(timestamp) {
      return moment(parseInt(timestamp)).format('M/DD/YY')
    },
    viewTimeline(uid) {
      this.$router.push({ path: '/dashboard', query: { uid }})
    },
    viewDocs(uid) {
      this.$router.push({ path: '/documents', query: { uid }})
    },
    checkAll(e) {
      const checked = e.target.checked
      document.querySelectorAll('input[type=checkbox]').forEach(element => element.checked = checked)
    },
    async deleteUsers() {
      const checks = document.querySelectorAll('.client-row input:checked')
      checks.forEach(async checkbox => {
        const uid = checkbox.value
        // Don't let users delete themselves
        if (uid === this.userProfile?.uid) {
          return
        }
        this.deleting = true
        deleteUser(uid).then(deleted => {
          if (deleted) {
            checkbox.closest('tbody').removeChild(checkbox.closest('tr'))
          }
          this.deleting = false
        })
        .catch(error => {
          console.log("Remove failed: " + error.message)
          this.deleting = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.clients {
  &__list {
    &__search {
      margin: 1rem 0;
      text-align: center;
    }
    &__table {
      max-width: 100%;
      overflow: auto;
      table {
        border: solid 1px $c-border;
        border-collapse: collapse;
        td, th {
          padding: 1rem;
          white-space: nowrap;
          &.action-required {
            position: relative;
            background-color: #fff4a3;
          }
        }
        thead {
          th {
            background-color: #eee;
          }
        }
        tbody {
          tr {
            background-color: #fff;
          }
          tr:nth-child(2n) {
            background-color: #eee;
          }
        }

        a {
          font-size: 14px;
          cursor: pointer;
          padding-right: 7px;
        }
      }
    }
  }
}
.actions {
  margin: 1rem;
  button {
    @include btn;
    min-width: 0;
    font-size: .75rem;
  }
}
</style>